export const PageNotFound = () => {
  return (
    <div className="flex size-full flex-1 items-center justify-center">
      <p className="text-title-lg">404</p>
    </div>
  );
};
